import axios from "axios";

const instance =axios.create({
    withCredentials: true,
    baseURL: `${process.env.REACT_APP_API_URL}`,
});

instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    if(error.response){
        // if(error.response.status===401){
        //     // window.location.href = '/';
            
        // }else if(error.response.status!==404&&error.response.status>401){
        //     console.log(error.response.status)
        //     window.location.href = '/error';
        // }
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });

export default instance


